import $ from 'jquery';
import { setLocalStorageCartAmount } from "../lib/cart-amount";

let product_amount = $( '.psh-counter__number--amount' );

$(document).on( 'change', product_amount, ( e ) => {
	if ( e.currentTarget.value < 0 ) {
		e.currentTarget.value = 0;
	}
} );

export const init_product_add_to_cart = () => {
	let timeout;

	$( document ).on( 'click', '.product__cart-add-to-cart .product-detail__actions__add-to-cart-button', function ( e ) {
		e.preventDefault();
	} );

	$( document ).on( 'click', '.product__cart-add-to-cart .product__cart-add-to-cart__button, .product-detail__actions__add-to-cart-button', function ( e ) {
		if ( $( e.currentTarget ).data('is-loading') ) {
			return false;
		}

		$( e.currentTarget ).data('is-loading', true);

		const is_disabled = $(e.currentTarget).hasClass('disabled');
		if ( is_disabled ) {
			return false;
		}

		let button = $( this ),
				stock,
				product_amount,
				branch_items;


		if ( button.hasClass( 'product__cart-add-to-cart__button' ) ) {
			stock = $( this ).data( 'stock_amount' );
			product_amount = $( this ).parent().parent().find( '.psh-counter__number' ).val();
			branch_items = $( this ).data( 'customer_branch' );
		}

		if ( button.hasClass( 'product-detail__actions__add-to-cart-button' ) ) {
			const availableStock = $( '.available-stock tbody' );
			branch_items = {};

			availableStock.find( '.available-stock__location' ).each( function () {
				branch_items[$(this).data('branch')] = {
					'product_amount': $(this).find('.psh-counter__number--amount').val(),
					'stock_amount': $(this).children('.available-stock--Amount').data('amount')
				};
			} );

			product_amount = $( '.product-detail__actions__add-to-cart__total' ).text();
			checkTotalAddToCart( parseInt( product_amount ) );
		}

		let notification_panel = $( '.notification-panel' );
		let loading = $( this ).parent().find( '.product__loading-image' );
		let $psh_counter = $( this ).parent().parent().find( '.psh-counter' );

		if ( typeof button.data( 'article-number' ) === undefined || button.data( 'article-number' ).length <= 0 ) {
			let $fallbackArticleNumber = $( '#product-detail__actions' )
			if ( $fallbackArticleNumber.length > 0 && typeof $fallbackArticleNumber.data( 'article-number' ) !== undefined && $fallbackArticleNumber.data( 'article-number' ).length >= 0 ) {
				button.data( 'article-number', $fallbackArticleNumber.data( 'article-number' ) );
			}
		}

		let backorderStatus = $( this ).attr('data-backorder');

		$.ajax( {
			type: 'POST',
			url: psh_vars.rest_route.psh_product_add_to_cart,
			data: {
				stock_amount: stock,
				psh_number: button.data( 'psh_number' ),
				product_name: button.data( 'product_name' ),
				product_amount: product_amount,
				unit_price: button.data( 'unit_price' ),
				article_number: button.data( 'article-number' ),
				short_code: button.data( 'short-code' ),
				customer_branch: branch_items,
				backorder_status: backorderStatus
			},
			beforeSend: () => {
				if ( button.hasClass( 'product__cart-add-to-cart__button' ) ) {
					button.hide();
				}

				if ( typeof $psh_counter !== undefined && $psh_counter.length > 0 ) {
					if ( $psh_counter[0].classList.contains('psh-counter--width') ) {
						$psh_counter[0].classList.remove('psh-counter--width');
					}
				}

				loading.show();
			},
			complete: () => {
				loading.hide();

				if ( typeof $psh_counter !== undefined && $psh_counter.length > 0 ) {
					$psh_counter[0].classList.add('psh-counter--width');
				}

				button.show();
				$( e.currentTarget ).data('is-loading', false);
			},
			success: data => {
				if ( timeout ) {
					clearTimeout(timeout)
				}

				let message_style = data.success ? 'success' : 'error';
				let cart_message;

				setLocalStorageCartAmount(data.cartIconAmount);

				$( '.add-to-cart__messages' ).remove();
				data.message.forEach( message => {
					notification_panel.append( '<div class="add-to-cart__messages">' + message + '</div>' );
					cart_message = $( '.add-to-cart__messages' );
					cart_message.addClass( message_style );
					cart_message.show();

					timeout = setTimeout( function () {
						cart_message.hide();
						$( '.add-to-cart__messages' ).remove();
						cart_message.removeClass( 'success error' );
					}, 7000 );
				} );
			}
		} );
	} );
};

export const checkTotalAddToCart = () => {
	const addToCartButton = $( '.product-detail__actions__add-to-cart-button > button' );
	let $addToCartTotal = $( '.product-detail__actions__add-to-cart__total' );

	if ( parseInt( $addToCartTotal.text() ) === 0 ) {
		addToCartButton.prop( 'disabled', true );
	} else {
		addToCartButton.prop( 'disabled', false );
	}
};

init_product_add_to_cart();